/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CmsHomepageBannerFormatEnumType = "BURN_IN" | "CAPTION" | "%future added value";
export type HpRespTopHeroBannerModule_componentModule = {
    readonly messages: {
        readonly items: ReadonlyArray<{
            readonly format: CmsHomepageBannerFormatEnumType | null;
            readonly cmsId: number | null;
            readonly isFullBleedImage: boolean | null;
            readonly imageUrl: string | null;
            readonly linkData: {
                readonly path: string | null;
            };
            readonly " $fragmentRefs": FragmentRefs<"HpRespTopHeroBannerImageItem_bannerItem" | "HpRespSharedHeroBanner_topItem">;
        } | null> | null;
    } | null;
    readonly " $refType": "HpRespTopHeroBannerModule_componentModule";
};
export type HpRespTopHeroBannerModule_componentModule$data = HpRespTopHeroBannerModule_componentModule;
export type HpRespTopHeroBannerModule_componentModule$key = {
    readonly " $data"?: HpRespTopHeroBannerModule_componentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespTopHeroBannerModule_componentModule">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userType"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpRespTopHeroBannerModule_componentModule",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "userType",
          "variableName": "userType"
        }
      ],
      "concreteType": "TopHeroBannerMessages",
      "kind": "LinkedField",
      "name": "messages",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TopHeroBannerItem",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "format",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cmsId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isFullBleedImage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "imageUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "LinkData",
              "kind": "LinkedField",
              "name": "linkData",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "path",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "HpRespTopHeroBannerImageItem_bannerItem"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "HpRespSharedHeroBanner_topItem"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TopHeroBannerModule",
  "abstractKey": null
};
(node as any).hash = 'e60bfa2be4a7a10af1edc37e0f52c994';
export default node;
